var modCheckoutEmail = function(){
    var scope = ".js-mod-checkout-email";
    var scopeCart = ".js-mod-cart-detail";

    function getCartDetail(){
        var $mod = $(scope);
        var $cartModal = $mod.find(scope+"__cart-detail");
        if($cartModal && $cartModal.length>0){
            gvf.endpoint(
                "web\\shopProcessController::showViewCartDetail",
                null,
                function(response){
                    if(response){
                        var $cartModal = $mod.find(scope+"__cart-detail");
                        var $html = $(response.html);
                        $html.removeClass("web-mod-cart-detail");
                        $cartModal.append($html);
                        ui.init($cartModal);
                    }else{
                        utils.alertEndpointResponse(response);
                    }
                }
            );
        }
    }

    ui.ready(
        scope,
        function($mod){
            var $confirmButton = $mod.find(scope+"__confirm-step");
            getCartDetail();

            $mod.find("[data-name='email']").keyup(
                function(ev){
                    gvf.delay(
                        500,
                        function(){
                            $confirmButton.show();
                            var modal = $mod.find(scope+"__create-modal");
                            if(modal){
                                modal.html('');
                            }
                        }
                    );
                }
            );

            $confirmButton.click(function(ev){
                ev.preventDefault();
                ev.stopPropagation();
                console.log("confirm step email");
                $confirmButton.prop("disabled",true);
                var email = $mod.find("[data-name='email']").formFieldVal();
                if(email){
                    gvf.endpoint(
                        "web\\shopProcessController::confirmEmailStep",
                        [$mod.data("step"),{email: email}],
                        function(response){
                            $confirmButton.prop("disabled",false);
                            if(response.html){
                                var modal = $mod.find(scope+"__create-modal");
                                if(modal){
                                    var htmlnode = modal.html(response.html);
                                    ui.init(modal);
                                    $confirmButton.hide();
                                }
                            }else if(response.message){
                                utils.alertEndpointResponse(response);
                            }else if(response.url && response.status=="ok"){
                                window.location = response.url;
                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }else{
                    $confirmButton.prop("disabled",false);
                }
            });

            $mod.on("submit",".js-mod-checkout-email__form",function(ev){
                ev.preventDefault();
                confirmLogin();
            });

            $mod.on("click",scope+"__modal-login",function(ev){
                ev.preventDefault();
                ev.stopPropagation();
                confirmLogin();
            });

            function confirmLogin(){
                var $loginForm = $mod.find(scope+"__create-modal .js-form");
                var isOk = $loginForm.checkRestrictions();
                if(isOk){
                    gvf.endpoint(
                        "web\\loginController::login",
                        [$loginForm.getValues()],
                        function(response){
                            if(response.status=="ok"){
                                window.location = response.url;
                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }else{
                }
            }

            $mod.on("click",scope+"__forget-pwd",function(ev){
                ev.preventDefault();
                ev.stopPropagation();
                var $loginForm = $mod.find(scope+"__create-modal .js-form");
                var values = $loginForm.getValues();
                var email = values.email;
                if(email){
                    gvf.endpoint(
                        "web\\loginController::resetPasswordRequest",
                        [email,$mod.find(scope+"__create-modal").attr("data-messaje-email")],
                        function(response){
                            if(response.status=="ok"){
                                utils.alertEndpointResponse(response);
                            }else{
                            }
                        }
                    );
                }
            });

        }
    );
}();
